export default __webpack_public_path__ + "static/media/persona-template.951cdd40.pptx";